<template>
	<div>
		<v-data-table
			:headers="header"
			:items="items"
			:footer-props="footer"
			:hide-default-footer="items.length <= 10"
			:page.sync="page"
			hide-default-header
			class="cursor-pointer"
			@click:row="goToItem"
		>
			<template #[`item._type`]="{ item }">
				<span
					v-for="i in parseType(item)"
					:key="i"
					class="move-type"
					v-text="i"
				/>
			</template>

			<template #[`item._created`]="{ value }">
				{{ parseDate(value) }}
			</template>
			<template #[`item._owner`]="{ value }">
				{{ parseOwner(value) }}
			</template>
			<template #[`item._communityId`]="{ value }">
				{{ parseCommunity(value) }}
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import _ from 'lodash';

export default {
	data() {
		return {
			header: [
				{ value: "_owner" },
				{ value: "_type" },
				{ value: "_communityId" },
				{ value: "_created" },
			],
			footer: {
				showCurrentPage: true,
				disableItemsPerPage: true,
				itemsPerPageOptions: [],
				itemsPerPageText: "",
			},
			page: 1,
		};
	},

	computed: {
		...mapGetters("tickets/roomMoves", ["items"]),
		...mapGetters({ getCommunity: 'communities/itemById'}),
	},

	watch: {
		page(page) {
			// eslint-disable-next-line eqeqeq
			if (page != this.$route.query.page)
				this.$router.replace({ name: this.$route.name, query: { page }});
		}
	},

	async created() {
		// Refetchs items when it's a new navigation to the NOC
		// The page query resets when we route out of room moves
		await this.getItems(!this.$route.query.page);
		const page = this.$route.query.page;
		if (page) this.page = Number(page);
	},

	methods: {
		...mapActions("tickets/roomMoves", ["getItems"]),
		
		...mapMutations({ setCurrent: "tickets/roomMoves/SET_CURRENT" }),

		parseType({ _type, moveOut, roomMove, moveIn }) {
			const result = [ _.startCase(_type) ];

			if (_type === "roomMove") {
				result.push(`(${roomMove._from} - ${roomMove._to})`);
			} else {
				result.push(`(${moveOut?._from || moveIn?._to})`);
			}

			return result;
		},

		parseDate(date) {
			return new Date(date).toDateString();
		},

		parseOwner(_owner) {
			return (_owner && typeof _owner == 'object') ? `${ _owner.preferredName || _owner.firstName} ${_owner.lastName}` : 'Unknown';
		},

		parseCommunity(communityId) {
			const community = this.getCommunity(communityId);
			return community?.name;
		},

		goToItem(item) {
			this.setCurrent(item);
			this.$router.push({ path: item._id, append: true });
		},
	},
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
	cursor: pointer;
}

.move-type {
	&:nth-of-type(1)::after {
		content: " ";
	}
	&:nth-of-type(2) {
		font-weight: 500;
	}
}
</style>
